var React = require('react');

function CaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.594 6.216l5.16 4.526a.675.675 0 010 1.042.926.926 0 01-1.189 0L8 7.78l-4.565 4.005a.926.926 0 01-1.189 0 .675.675 0 010-1.042l5.16-4.526A.9.9 0 018 6c.215 0 .43.072.594.216z","fill":"black"}));
}

CaretUp.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = CaretUp;

CaretUp.default = CaretUp;
